export function mapTraineeListOrder(order: string): string {
  const parts = order.split(':')
  if (parts[0] === 'fullName') {
    return `firstName:${parts[1]},lastName:${parts[1]}`
  }
  return order
}